// class LocalizationForm extends HTMLElement {
//   constructor() {
//     super();
//     this.elements = {
//       input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
//       button: this.querySelector('button'),
//       panel: this.querySelector('ul'),
//     };
//     this.elements.button.addEventListener('click', this.openSelector.bind(this));
//     this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
//     this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

//     this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
//   }

//   hidePanel() {
//     this.elements.button.setAttribute('aria-expanded', 'false');
//     this.elements.panel.setAttribute('hidden', true);
//   }

//   onContainerKeyUp(event) {
//     if (event.code.toUpperCase() !== 'ESCAPE') return;

//     this.hidePanel();
//     this.elements.button.focus();
//   }

//   onItemClick(event) {
//     event.preventDefault();
//     const form = this.querySelector('form');
//     this.elements.input.value = event.currentTarget.dataset.value;
//     if (form) form.submit();
//   }

//   openSelector() {
//     this.elements.button.focus();
//     this.elements.panel.toggleAttribute('hidden');
//     this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
//   }

//   closeSelector(event) {
//     const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
//     if (event.relatedTarget === null || shouldClose) {
//       this.hidePanel();
//     }
//   }
// }

// customElements.define('localization-form', LocalizationForm);


// class LocalizationForm extends HTMLElement {
//   constructor() {
//     super();
//     this.elements = {
//       input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
//       button: this.querySelector('button'),
//       panel: this.querySelector('ul'),
//     };

//     // Додаємо обробники подій
//     this.elements.button.addEventListener('click', this.toggleSelector.bind(this));
//     this.elements.button.addEventListener('blur', this.closeSelector.bind(this));
//     this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

//     this.querySelectorAll('a').forEach(item =>
//       item.addEventListener('click', this.onItemClick.bind(this))
//     );
//   }

//   hidePanel() {
//     this.elements.button.setAttribute('aria-expanded', 'false');
//     this.elements.panel.setAttribute('hidden', 'true');
//   }

//   showPanel() {
//     this.elements.button.setAttribute('aria-expanded', 'true');
//     this.elements.panel.removeAttribute('hidden');
//   }

//   toggleSelector(event) {
//     const isExpanded = this.elements.button.getAttribute('aria-expanded') === 'true';
//     if (isExpanded) {
//       this.hidePanel();
//     } else {
//       this.showPanel();
//     }
//   }

//   closeSelector(event) {
//     // Закриваємо панель, якщо фокус пішов з кнопки або панелі
//     if (!this.contains(event.relatedTarget)) {
//       this.hidePanel();
//     }
//   }

//   onContainerKeyUp(event) {
//     if (event.code.toUpperCase() === 'ESCAPE') {
//       this.hidePanel();
//       this.elements.button.focus();
//     }
//   }

//   onItemClick(event) {
//     event.preventDefault();
//     const form = this.querySelector('form');
//     this.elements.input.value = event.currentTarget.dataset.value;
//     if (form) form.submit();
//   }
// }

// customElements.define('localization-form', LocalizationForm);


class LocalizationForm extends HTMLElement {
  static activeForm = null;

  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };

    this.elements.button.addEventListener('click', this.toggleSelector.bind(this));
    this.elements.button.addEventListener('blur', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item =>
      item.addEventListener('click', this.onItemClick.bind(this))
    );
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', 'true');
  }

  showPanel() {
    if (LocalizationForm.activeForm && LocalizationForm.activeForm !== this) {
      LocalizationForm.activeForm.hidePanel();
    }

    this.elements.button.setAttribute('aria-expanded', 'true');
    this.elements.panel.removeAttribute('hidden');
    LocalizationForm.activeForm = this;
  }

  toggleSelector(event) {
    const isExpanded = this.elements.button.getAttribute('aria-expanded') === 'true';
    if (isExpanded) {
      this.hidePanel();
      LocalizationForm.activeForm = null;
    } else {
      this.showPanel();
    }
  }

  closeSelector(event) {
    if (!this.contains(event.relatedTarget)) {
      this.hidePanel();
      if (LocalizationForm.activeForm === this) {
        LocalizationForm.activeForm = null;
      }
    }
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() === 'ESCAPE') {
      this.hidePanel();
      this.elements.button.focus();
      if (LocalizationForm.activeForm === this) {
        LocalizationForm.activeForm = null;
      }
    }
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define('localization-form', LocalizationForm);
